module.exports = __webpack_public_path__ + "static/logo-eao-e713d75df6e4ddd2bf9a49e9f7a34cd0.png";